var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPayment2 = function SvgPayment2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4987 21.8026C15.0036 22.4668 15.6614 22.9992 16.4162 23.3546C17.1709 23.7101 18.0004 23.8781 18.834 23.8443C21.4917 23.8443 23.6477 22.2273 23.6477 20.2346C23.6477 18.242 21.4917 16.6273 18.834 16.6273C16.1763 16.6273 14.0227 15.0103 14.0227 13.0153C14.0227 11.0203 16.1787 9.40562 18.834 9.40562C19.6676 9.37183 20.497 9.5398 21.2518 9.89526C22.0066 10.2507 22.6644 10.7831 23.1693 11.4473",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8352 23.8443V26.25",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8352 7V9.40567",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2493 48.9673L50.7727 43.75V31.5C50.7727 26.8333 41.906 21.8423 38.5227 19.25",
    stroke: "#7EAAFF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0272 34.5193L34.5152 27.6966C33.9449 27.1263 33.1715 26.806 32.365 26.806C31.5585 26.806 30.7851 27.1263 30.2148 27.6966C29.6446 28.2668 29.3242 29.0403 29.3242 29.8468C29.3242 30.6532 29.6446 31.4267 30.2148 31.9969L38.4585 41.2999V47.1333C38.4585 49.8889 42.3972 54.2383 42.3972 54.2383",
    stroke: "#7EAAFF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5227 54.25H4.97866C4.12816 54.2494 3.3127 53.9111 2.71153 53.3095C2.11035 52.7079 1.77266 51.8922 1.77266 51.0417V4.95833C1.77266 4.10783 2.11035 3.29214 2.71153 2.69052C3.3127 2.08891 4.12816 1.75062 4.97866 1.75H35.312C36.1631 1.75 36.9794 2.08795 37.5814 2.68956C38.1835 3.29117 38.522 4.10722 38.5227 4.95833V30.9097",
    stroke: "#7EAAFF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5227 33.25H10.5227C10.0585 33.25 9.61341 33.4344 9.28522 33.7626C8.95703 34.0908 8.77266 34.5359 8.77266 35V45.5C8.77266 45.9641 8.95703 46.4092 9.28522 46.7374C9.61341 47.0656 10.0585 47.25 10.5227 47.25H31.5227",
    stroke: "#7EAAFF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77266 40.25H28.0227",
    stroke: "#7EAAFF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2727 33.25V47.25",
    stroke: "#7EAAFF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayment2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payment2.cb16815a.svg";
export { ForwardRef as ReactComponent };